import { useState } from 'react';

const usePieChartTile = () => {
  const [isPieChartDrawerOpen, setIsPieChartDrawerOpen] = useState(false);

  const handleClosePieChartDrawer = () => {
    setIsPieChartDrawerOpen(false);
  };

  const handleClick = () => {
    setIsPieChartDrawerOpen(true);
  };

  return { isPieChartDrawerOpen, handleClosePieChartDrawer, handleClick };
};

export default usePieChartTile;
